import styled from 'styled-components'

export const FormContent = styled.div`
  max-width: 320px;
  margin: 0 auto;
  margin-top: 16px;
`
